import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { useCountUp } from './hooks/useCountUp'


const STATS = [
    { target: 300, suffix: '+', label: 'In-House Engineers' },
    { target: 100, suffix: '+', label: <>Active Projects<br />Across The Globe</> },
    { target: 20, suffix: '+', label: 'Years And Counting' },
    { target: 6, suffix: '+', label: 'Business Verticals' },
    { target: 1, suffix: '', label: 'Manufacturing Plant' },
]
 
const useStyles = makeStyles(() => ({
    section: { background: tokens.colorPrimary, padding: '46px 0' },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: 20,
        textAlign: 'center',
        '@media (max-width: 640px)': { gridTemplateColumns: '1fr 1fr', rowGap: 30 },
    },
    number: {
        display: 'block',
        fontFamily: tokens.fontHeading,
        color: '#fff',
        fontSize: '4rem',
        fontWeight: 400,
        lineHeight: 1,
        marginBottom: 10,
    },
    label: { color: '#DADCF4', fontSize: '1.2rem',  margin: 0, fontFamily: tokens.fontBody },
}))
 
function StatItem({ stat }) {
    const classes = useStyles()
    const { ref, display } = useCountUp(stat.target, stat.suffix)
 
    return (
        <div ref={ref}>
            <span className={classes.number}>{display}</span>
            <span className={classes.label}>{stat.label}</span>
        </div>
    )
}
 
export function Stats() {
    const classes = useStyles()
    return (
        <section className={classes.section}>
            <Container className={classes.grid}>
                {STATS.map((stat, i) => (
                    <StatItem stat={stat} key={i} />
                ))}
            </Container>
        </section>
    )
}